import { Link, useLocation } from "react-router-dom";

import { SamphireLogo } from "../assets/logos/samphireLogo";
import { Button } from "../components/coreUI/button";

export default function VerifyEmail() {
  const location = useLocation();
  const { email } = location.state || {};

  return (
    <div className="w-screen h-screen pt-12 items-center justify-center ">
      <div className="max-w-[350px] mx-auto flex flex-col items-center justify-center my-auto ">
        <div className="w-full h-full flex flex-col items-center justify-center mt-8 mb-8 px-8">
          <Link to="/" className="cursor-pointer">
            <SamphireLogo width={200} className="text-foreground-primary" />
          </Link>
          <p className="text-xl font-semibold text-foreground-secondary">
            Member Portal
          </p>
          <div className="mt-4 flex flex-col w-full gap-2 text-center">
            <h2 className="text-xl font-semibold text-foreground-primary">
              Check your email
            </h2>
            <p className="ph-no-capture text-sm text-foreground-secondary mb-2">
              We've sent a verification link to{" "}
              <span style={{ fontWeight: "600" }}>{email}</span>
            </p>
            <p className="text-sm text-foreground-secondary mb-2">
              Please check your email and click the verification link to
              complete your registration.
            </p>
            <p className="text-sm text-foreground-secondary mb-2">
              Didn't receive the email? Check your spam folder or try signing up
              again.
            </p>

            <div className="mt-2">
              <Button
                variant="primary"
                size="default"
                as="link"
                to="/auth?mode=signup"
              >
                Try signing up again
              </Button>
              <Button
                variant="tertiary"
                size="default"
                as="link"
                to="/auth?mode=login"
              >
                Back to sign in
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
